import { Button, Modal } from 'react-bootstrap'
import bgrWin from "assets/images/eventBunpimay/brgPopupWin.png"
import { ModalCloseBunpimaySVG } from 'assets/svg/ModalSVG/ModalCloseBunpimaySVG'
import { useEffect, useState } from 'react'
import ModalBunpimayPairingSuccess from './ModalBunpimayPairingSuccess'
import iconWaterTank from 'assets/images/eventBunpimay/waterTank.png'
import iconGun from 'assets/images/eventBunpimay/gunBody.png'

function ModalBunpimayPairingSuccessTransition({
	show,
	onHide,
	children,
	numberPairing = 0,
	srcImgHeader = null,
	classProp = "",
	...otherProps
}) {
	const [onShow, setOnShow] = useState(false)
	function upgradeEffect() {
		const leftCard = document.querySelector(".card-left");
		const rightCard = document.querySelector(".card-right");
		const explosion = document.querySelector(".explosion");
		const lightEffect = document.querySelector(".light-effect");
		const lensFlare = document.querySelector(".lens-flare");
		const orbit = document.querySelector(".orbit");

		// 1. Hai thẻ di chuyển vào trung tâm
		leftCard.style.animation = "translateLeft 2.01s linear infinite";
		rightCard.style.animation = "translateRight 2.01s linear infinite";
		setTimeout(() => {
			orbit.style.animation = "rotateYOrbit 0.75s linear infinite";
		}, 500);

		setTimeout(() => {
			// 3. Làm biến mất hai thẻ
			leftCard.style.opacity = "0";
			rightCard.style.opacity = "0";
		}, 2000);

		setTimeout(() => {
			// 4. Hiệu ứng ánh sáng và nổ
			explosion.style.transform = "translate(-50%, -50%) scale(3.5)";
			explosion.style.opacity = "1";
			lightEffect.style.transform = "translate(-50%, -50%) scale(3)";
			lightEffect.style.opacity = "1";
			lensFlare.style.transform = "translate(-50%, -50%) scale(4)";
			lensFlare.style.opacity = "1";
		}, 2100);

		setTimeout(() => {
			// 5. Làm hiệu ứng ánh sáng biến mất
			explosion.style.opacity = "0";
			lightEffect.style.opacity = "0";
			lensFlare.style.opacity = "0";
		}, 2600);

		setTimeout(() => {
			setOnShow(true)
		}, 2700);
	}
	useEffect(() => {
		if (show) {
			upgradeEffect()
		}
	}, [show])
	return (
		<>
			<Modal
				show={show}
				onHide={() => {
					onHide();
					setOnShow(false);
				}}
				{...otherProps}
				size="xl"
				animation={false}
				aria-labelledby="contained-modal-title-vcenter"
				centered
				className={`modal-event-transition `}
				backdrop={true}
			>
				<div className='container-modal-success'>
					<div className='orbit'>
						<div className="card card-left">
							<div className='info'><img draggable="false" className="icon-item" src={iconWaterTank} /></div>
						</div>
						<div className="card card-right">
							<div className='info'><img draggable="false" className="icon-item" src={iconGun} /></div>
						</div>
					</div>
					<div className="explosion"></div>
					<div className="light-effect"></div>
					<div className="lens-flare"></div>

				</div>
				<ModalBunpimayPairingSuccess
					show={onShow}
					numberPairing={numberPairing}
					onHide={() => {
						onHide();
						setOnShow(false);
					}
					}
				/>

			</Modal>
		</>
	)
}

export default ModalBunpimayPairingSuccessTransition
